import { FC, memo, useState } from "react";
import "react-multi-carousel/lib/styles.css";

import { ArrowRight, Close, Email, Phone } from "@carbon/icons-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

type Props = {
  email?: string;
};

const ContactProfile: FC<Props> = ({ email }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <Dialog
        open={openModal}
        onOpenChange={setOpenModal}
      >
        <DialogTrigger asChild>
          <Button
            variant="outline"
            onClick={() => setOpenModal(true)}
          >
            Chỉnh sửa
          </Button>
        </DialogTrigger>
        <DialogContent className={"sm:max-w-[600px]  bg-white "}>
          <DialogHeader className="relative">
            <Button
              variant="ghost"
              size="sm"
              className="absolute top-0 right-0 rounded-full w-[36px]"
              onClick={() => {
                setOpenModal(false);
              }}
            >
              <Close />
            </Button>
            <DialogTitle className="text-center max-w-[460PX] text-lg mx-auto">
              Thông tin liên hệ
            </DialogTitle>
          </DialogHeader>
          <div className="grid gap-4 pb-[12px] h-full">
            <div className="h-14 px-3 py-4 bg-white rounded border border-secondary-200 justify-start items-center gap-3 inline-flex">
              <Email />
              <div className="h-6 w-full text-left">
                <span className="text-secondary-900 text-base font-normal ">
                  {email}
                </span>
              </div>
              <ArrowRight />
            </div>
            <div className="h-14 px-3 py-4 bg-white rounded border border-secondary-200 justify-start items-center gap-3 inline-flex">
              <Phone />
              <div className="h-6 w-full text-left">
                <span className="text-secondary-900 text-base font-normal ">
                  {email}
                </span>
              </div>
              <ArrowRight />
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default memo(ContactProfile);
